import { useQuery } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry CTC job numbers already linked to a Firetrol job. */
export function useLinkedCtcJobs(enabled = true) {
  return useQuery({
    queryKey: queryKeys.ctc.linkedJobs(),
    queryFn: ({ signal }) => ctcApiClient.loadLinkedJobs(toCancelToken(signal)),
    enabled,
    staleTime: 60_000,
    meta: { errorContext: 'linked CTC jobs' },
  });
}
